import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Button, Checkbox } from '@mui/material';
import { Card, TextField } from '@totalsoft/rocket-ui';
import { AssignmentOutlined as AssignmentOutlinedIcon } from '@mui/icons-material';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_DMS_WRITE } from 'constants/rightsCodes';
import { emptyString } from 'utils/constants';
import { get, set } from '@totalsoft/change-tracking-react';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

const ContentTypeGeneralDataComponent = ({ lens, isDirty, saving, onSave, validation }) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_DMS_WRITE);

  return (
    <Card icon={AssignmentOutlinedIcon} iconColor='primary' title={t('ContentTypes.GeneralData')}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <TextField
            required
            fullWidth
            value={get(lens.name) || emptyString}
            onChange={set(lens.name)}
            label={t('ContentTypes.Name')}
            disabled={!canWrite}
            error={!isValid(validation.name)}
            helperText={getErrors(validation.name)}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={4}>
          <TextField
            required
            fullWidth
            value={get(lens.code) || emptyString}
            onChange={set(lens.code)}
            label={t('ContentTypes.Code')}
            disabled={!canWrite}
            error={!isValid(validation.code)}
            helperText={getErrors(validation.code)}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={4}>
          <FormControlLabel
            control={
              <Checkbox checked={get(lens.isFileType) || false} onClick={lens.isFileType |> set |> onCheckBoxChange} disabled={!canWrite} />
            }
            label={t('ContentTypes.IsFile')}
            labelPlacement='end'
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} pt={2} justifyContent='flex-end'>
        <Button color='primary' variant='contained' disabled={!isDirty || !canWrite || saving} onClick={onSave}>
          {saving ? t('Saving') : t('Save')}
        </Button>
      </Grid>
    </Card>
  );
};

ContentTypeGeneralDataComponent.propTypes = {
  lens: PropTypes.object.isRequired,
  isDirty: PropTypes.bool,
  saving: PropTypes.bool,
  onSave: PropTypes.func,
  validation: PropTypes.object
};

export default ContentTypeGeneralDataComponent;
